import React from "react";
import mock05 from '../assets/images/mock05.png';
import mock07 from '../assets/images/mock07.png';
import mock10 from '../assets/images/mock10.png';
import dongnaeMoa from '../assets/images/dongnae-moa.png';
import palJung from '../assets/images/pal-jung.png';
import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Personal Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://anki.mjiho.com/" target="_blank" rel="noreferrer"><img src={mock10} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://anki.mjiho.com/" target="_blank" rel="noreferrer"><h2>SentenceAnki</h2></a>
                <p>Developed a web application that helps users memorize English sentences using spaced repetition.</p>
            </div>
            <div className="project">
                <a href="https://udok.mjiho.com/" target="_blank" rel="noreferrer"><img src={mock05} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://udok.mjiho.com/" target="_blank" rel="noreferrer"><h2>Udok </h2></a>
                <p>Developed a web application that shows remaining seats for Umyeonsan Studying Zone(Not in service yet).</p>
            </div>
            <div className="project">
                <a href="https://social.mjiho.com/" target="_blank" rel="noreferrer"><img src={mock07} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://social.mjiho.com/" target="_blank" rel="noreferrer"><h2>Studying Tools</h2></a>
                <p>Developed various kinds of studying tools to help students learn more effectively.</p>
            </div>
            <div className="project">
                <a href="https://github.com/dongnae-moa/" target="_blank" rel="noreferrer"><img src={dongnaeMoa} className="zoom project-image--portrait" alt="Dongnae-Moa mission map and community mission screen" width="100%"/></a>
                <a href="https://github.com/dongnae-moa/" target="_blank" rel="noreferrer"><h2>Dongnae-Moa · 동네모아</h2></a>
                <p>A neighborhood participation platform that turns local problems into short, photo-verified missions residents can solve together.</p>
                <div className="project-links">
                    <a href="https://github.com/dongnae-moa/" target="_blank" rel="noreferrer">View on GitHub ↗</a>
                </div>
            </div>
            <div className="project">
                <a href="https://paljung.mjiho.com/" target="_blank" rel="noreferrer"><img src={palJung} className="zoom project-image--portrait" alt="Pal Jung relationship dashboard on a mobile screen" width="100%"/></a>
                <a href="https://paljung.mjiho.com/" target="_blank" rel="noreferrer"><h2>Pal Jung · 팔정</h2></a>
                <p>A privacy-first Flutter app that helps people review Instagram follower relationships locally and organize who to keep, review, or clean up.</p>
                <div className="project-links">
                    <a href="https://paljung.mjiho.com/" target="_blank" rel="noreferrer">Live demo ↗</a>
                    <a href="https://github.com/elliot-min/pal_jung" target="_blank" rel="noreferrer">GitHub ↗</a>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Project;
